export default "__VITE_ASSET__D1pwM4iS__"